// Stagging Base URLS
export const joinUrl = (base, path) =>
  `${String(base || "").replace(/\/+$/, "")}/${String(path || "").replace(/^\/+/, "")}`;

export const baseURL = String(import.meta.env.VITE_API_ENDPOINT || "").replace(
  /\/+$/,
  "",
);
export const getS3BucketURL = import.meta.env.VITE_S3_BUCKET_ENDPOINT;
const apiVersion = "v1";
const domain = joinUrl(baseURL, apiVersion);
// EndPoints
export const endPoints = {
  // Register User
  Register: `${domain}/registration/`,

  // Register User
  ForgetPassword: `${domain}/forget-password/`,

  // Register User
  ResetPassword: `${domain}/reset-password/`,
  ConfirmChatMedia: `${domain}/chat/media/confirm/`,
  ChatAttachmentDownloadUrl: `${domain}/chat/media/download-url/`,

  // Login User
  Login: `${domain}/login/`,

  // Token Refresh
  TokenRefresh: `${domain}/token/refresh/`,
  SecurityOtpRequest: `${domain}/security/otp/request/`,
  SecurityOtpVerify: `${domain}/security/otp/verify/`,

  // Google Auth
  GoogleAuth: `${domain}/google-auth/`,

  // Logout
  Logout: `${domain}/logout/`,

  // Roles & Inetrests
  RolesInterests: `${domain}/roles-interests/`,

  // States
  States: `${domain}/fetch-states/`,

  // Users
  Users: `${domain}/users/`,

  // User Detail
  GetProfileDetails: `${domain}/personal-info-detail/`,

  // Update User Detail
  UpdateProfileDetail: `${domain}/personal-info-update/`,

  // Skills
  Skills: `${domain}/user-skill/`,

  // Job Experience
  JobExperience: `${domain}/job-experience/`,

  // Project Experience
  ProjectExperience: `${domain}/project-experience/`,

  // Certidications
  Certifications: `${domain}/user-certificate/`,

  //Lisense
  License: `${domain}/user-license/`,

  // Recommendation
  Recommendation: `${domain}/user-recommendation/`,

  // Education
  Education: `${domain}/user-education/`,

  // Education
  SignupSuggestions: `${domain}/suggested-partners/`,

  // Partner Details
  partnerDetails: `${domain}/partner-detail/`,

  // Partner Status
  partnerStatus: `${domain}/partners/`,

  // Partners Listing
  partnerListing: `${domain}/interested-partners/`,

  // User Verification
  Verify: `${domain}/verify/`,

  // Top Rated
  TopRatedPartners: `${domain}/top_rated_partners/`,

  // Suggested Partners Details Api
  SuggestedPartnersDetails: `${domain}/suggested_partner_detail/`,

  // partner filter
  partnerFilter: `${domain}/partner/filter/`,

  // Partner network filter (search within your network)
  NetworkFilter: `${domain}/partner/network-filter/`,

  // Projects
  ProjectsList: `${domain}/projects/list/`,
  ProjectDetails: (id) => `${domain}/projects/${id}/`,
  ProjectTransfer: (id) => `${domain}/projects/${id}/transfer/`,
  CreateProject: `${domain}/projects/`,

  // Teams
  MyTeams: `${domain}/teams/my/`,
  TeamCreate: `${domain}/teams/`,
  // Teams Workspace
  TeamDetail: (teamId) => `${domain}/teams/${teamId}/`,
  TeamUpdate: (teamId) => `${domain}/teams/${teamId}/`,
  TeamStorage: (teamId) => `${domain}/teams/${teamId}/storage/`,
  TeamFilesList: (teamId, params) =>
    `${domain}/teams/${teamId}/storage/files/${params ? `?${params}` : ""}`,
  TeamFilesPresign: (teamId) => `${domain}/teams/${teamId}/storage/files/upload/presign/`,
  TeamFilesConfirm: (teamId) => `${domain}/teams/${teamId}/storage/files/upload/confirm/`,
  TeamFileDetail: (teamId, fileId) =>
    `${domain}/teams/${teamId}/storage/files/${fileId}/`,
  TeamFileUrl: (teamId, fileId) =>
    `${domain}/teams/${teamId}/storage/files/${fileId}/url/`,
  TeamFileShareCreate: (teamId, fileId) =>
    `${domain}/teams/${teamId}/storage/files/${fileId}/share/`,
  TeamFoldersTree: (teamId) => `${domain}/teams/${teamId}/storage/folders/tree/`,
  TeamFoldersCreate: (teamId) => `${domain}/teams/${teamId}/storage/folders/`,
  TeamFolderDetail: (teamId, folderId) =>
    `${domain}/teams/${teamId}/storage/folders/${folderId}/`,
  TeamTransferOwnership: (teamId) => `${domain}/teams/${teamId}/transfer-ownership/`,
  TeamMembers: (teamId) => `${domain}/teams/${teamId}/members/`,
  TeamMemberRole: (teamId, userId) => `${domain}/teams/${teamId}/members/${userId}/role/`,
  TeamMemberAccess: (teamId, userId) => `${domain}/teams/${teamId}/members/${userId}/access/`,
  TeamMemberRemove: (teamId, userId) => `${domain}/teams/${teamId}/members/${userId}/remove/`,
  TeamInvites: (teamId) => `${domain}/teams/${teamId}/invites/`,
  TeamInviteDelete: (teamId, inviteId) => `${domain}/teams/${teamId}/invites/${inviteId}/`,
  TeamInviteCreate: (teamId) => `${domain}/teams/${teamId}/invites/`,
  // Team Delete
  TeamDelete: (teamId) => `${domain}/teams/${teamId}/`,
  // Team Invite Accept / Detail
  TeamInviteDetail: (token) => `${domain}/teams/invites/${token}/`,
  TeamInviteAccept: (token) => `${domain}/teams/invites/${token}/accept/`,
  TeamInviteDecline: (token) => `${domain}/teams/invites/${token}/decline/`,


  // Files & Folders
  ProjectFilesList: (id, params) =>
    `${domain}/projects/${id}/files/${params ? `?${params}` : ""}`,
  ProjectFilesPresign: (id) => `${domain}/projects/${id}/files/upload/presign/`,
  ProjectFilesConfirm: (id) => `${domain}/projects/${id}/files/upload/confirm/`,
  ProjectFilesUsage: (id) => `${domain}/projects/${id}/files/usage/`,
  ProjectFileDetail: (projectId, fileId) =>
    `${domain}/projects/${projectId}/files/${fileId}/`,
  ProjectFileContent: (projectId, fileId) =>
    `${domain}/projects/${projectId}/files/${fileId}/content/`,
  ProjectFileDelete: (projectId, fileId) =>
    `${domain}/projects/${projectId}/files/${fileId}/`,
  ProjectFileShareCreate: (projectId, fileId) =>
    `${domain}/projects/${projectId}/files/${fileId}/share/`,
  ProjectFileSharePublic: (token) =>
    `${domain}/public/file-shares/${token}/`,
  ProjectFileSharePublicContent: (token) =>
    `${domain}/public/file-shares/${token}/content/`,
  ProjectFoldersTree: (id) => `${domain}/projects/${id}/folders/tree/`,
  ProjectFoldersCreate: (id) => `${domain}/projects/${id}/folders/`,
  ProjectFolderDetail: (projectId, folderId) =>
    `${domain}/projects/${projectId}/folders/${folderId}/`,
  ProjectFileAttachments: (projectId) =>
    `${domain}/projects/${projectId}/file-attachments/`,
  ProjectFileAttachmentDetail: (projectId, attachmentId) =>
    `${domain}/projects/${projectId}/file-attachments/${attachmentId}/`,
  ProjectTasksList: (id) => {
    return `${domain}/projects/${id}/tasks/list/`;
  },

  // Cross-Account Projects & Tasks (new endpoints)
  TasksList: `${domain}/tasks/list/`,
  CrossProjectGanttTasks: `${domain}/tasks/gantt/`,
  UpdateTaskStatus: (projectId, taskId) =>
    `${domain}/projects/${projectId}/tasks/${taskId}/status/`,
  CreateTask: (id) => `${domain}/projects/${id}/tasks/`,
  SwapTaskOrder: (id) => `${domain}/projects/${id}/tasks/swap/`,
  GanttTasks: (id) => `${domain}/projects/${id}/tasks/gantt/`,
  TaskDetails: (projectId, taskId) =>
    `${domain}/projects/${projectId}/tasks/${taskId}/`,
  TaskComments: (projectId, taskId) =>
    `${domain}/projects/${projectId}/tasks/${taskId}/comments/`,

  // Dashboard Stats
  DashboardStats: `${domain}/projects/dashboard-stats/`,
  Clients: `${domain}/clients/`,
  ClientDetail: (clientId) => `${domain}/clients/${clientId}/`,
  TaskTrend: `${domain}/projects/tasks/trend/`,
  UpcomingTasks: `${domain}/projects/tasks/upcoming/`,

  // Project Members
  ProjectMembersAdd: (id) => `${domain}/projects/${id}/members/add/`,
  ProjectMembersList: (id) => `${domain}/projects/${id}/members/`,
  ProjectInviteAccept: (token) => `${domain}/projects/invite/${token}/`,
  ProjectInviteDetail: (token) => `${domain}/projects/invite/${token}/`,
  ProjectInviteDashboardAccept: (memberId) =>
    `${domain}/projects/invitations/${memberId}/accept/`,
  ProjectInviteDashboardReject: (memberId) =>
    `${domain}/projects/invitations/${memberId}/reject/`,
  ProjectInviteDashboardCancel: (memberId) =>
    `${domain}/projects/invitations/${memberId}/cancel/`,

  ProjectMemberRemove: (projectId, userId) =>
    `${domain}/projects/${projectId}/members/${userId}/remove/`,
  ProjectMemberRoleUpdate: (projectId, userId) =>
    `${domain}/projects/${projectId}/members/${userId}/role/`,

  // Chat/GetMediaURL
  getMediaURL: `${domain}/chat/media_url/`,

  // saveMediaOnS3Bucket
  saveMediaOnS3Bucket: getS3BucketURL,

  // profile image
  profileImg: `${domain}/personal-info-update/`,
  uploadProfileImage: `${domain}/upload-profile-image/`,

  // Profile progress
  profileCompletion: `${domain}/profile_completion_percentage/`,

  PortfolioImages: `${domain}/portfolio-images/`,

  Notifications: `${domain}/notifications/`,
  RecentActivities: `${domain}/notifications/activities/recent/`,
  NotificationStats: `${domain}/notifications/stats/`,
  NotificationPreferences: `${domain}/notifications/preferences/`,
  UpdateNotificationPreferences: `${domain}/notifications/preferences/update/`,
  CancelNotification: (notificationId) =>
    `${domain}/notifications/${notificationId}/cancel/`,

  // Help & Support
  SupportArticles: `${domain}/support/articles/`,
  SupportArticleDetail: (slug) => `${domain}/support/articles/${slug}/`,
  SupportSubmissions: `${domain}/support/submissions/`,
  SupportSubmissionDetail: (publicId) =>
    `${domain}/support/submissions/${publicId}/`,
  SupportScreenshotUploadIntent: (publicId) =>
    `${domain}/support/submissions/${publicId}/attachments/screenshot/upload-intent/`,
  SupportScreenshotComplete: (publicId, attachmentId) =>
    `${domain}/support/submissions/${publicId}/attachments/${attachmentId}/complete/`,
  SupportScreenshotDelete: (publicId, attachmentId) =>
    `${domain}/support/submissions/${publicId}/attachments/${attachmentId}/`,
  SupportSubmissionSubmit: (publicId) =>
    `${domain}/support/submissions/${publicId}/submit/`,
  SupportAdminSubmissions: `${domain}/support/admin/submissions/`,
  SupportAdminSubmissionDetail: (publicId) =>
    `${domain}/support/admin/submissions/${publicId}/`,
  SupportAdminScreenshotDownload: (publicId, attachmentId) =>
    `${domain}/support/admin/submissions/${publicId}/attachments/${attachmentId}/download-url/`,

  ContractGenerate: `${domain}/chat/generate-contract/`,

  AIChatSessions: (projectId, params) => {
    let url = projectId
      ? `${domain}/ai-chat/sessions/?project_id=${projectId}`
      : `${domain}/ai-chat/sessions/`;
    if (params) {
      const searchParams = new URLSearchParams(params);
      url += (url.includes("?") ? "&" : "?") + searchParams.toString();
    }
    return url;
  },
  AIChatSessionDetail: (sessionId) => `${domain}/ai-chat/sessions/${sessionId}/`,
  AIChatMessages: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/messages/`,
  AIChatGenerateContract: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/generate/`,
  AIChatContractDetail: (contractId) =>
    `${domain}/ai-chat/contracts/${contractId}/`,
  AIChatStop: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/stop/`,
  AIChatGrant: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/permission-grant/`,
  AIChatGrantRevoke: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/permission-grant/revoke/`,
  AIChatAccessRequests: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/access-requests/`,
  AIChatAccessRequestInbox: () => `${domain}/ai-chat/access-requests/inbox/`,
  AIChatAccessRequestApprove: (requestId) =>
    `${domain}/ai-chat/access-requests/${requestId}/approve/`,
  AIChatAccessRequestDeny: (requestId) =>
    `${domain}/ai-chat/access-requests/${requestId}/deny/`,
  AIChatAccessRequestCancel: (requestId) =>
    `${domain}/ai-chat/access-requests/${requestId}/cancel/`,
  AIChatSummaryRegenerate: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/summary/regenerate/`,
  AIChatSummaryClear: (sessionId) =>
    `${domain}/ai-chat/sessions/${sessionId}/summary/clear/`,
  AIChatMessageCitations: (sessionId, messageId) =>
    `${domain}/ai-chat/sessions/${sessionId}/messages/${messageId}/citations/`,
  KnowledgeItems: (teamId) => `${domain}/knowledge/teams/${teamId}/items/`,
  KnowledgeItemDetail: (teamId, itemId) =>
    `${domain}/knowledge/teams/${teamId}/items/${itemId}/`,
  KnowledgeItemVerify: (teamId, itemId) =>
    `${domain}/knowledge/teams/${teamId}/items/${itemId}/verify/`,
  KnowledgeSearch: (teamId) => `${domain}/knowledge/teams/${teamId}/search/`,
  KnowledgeAnswer: (teamId) => `${domain}/knowledge/teams/${teamId}/answers/`,
  KnowledgeRelations: (teamId) =>
    `${domain}/knowledge/teams/${teamId}/relations/`,

  // Group Chat Members
  GroupMembers: (id) => `${domain}/chat/group/${id}/members/`,
  GroupAvailableUsers: (id) => `${domain}/chat/group/${id}/available-users/`,
  GroupAddMembers: (id) => `${domain}/chat/group/${id}/add-members/`,
  GroupRemoveMember: (id) => `${domain}/chat/group/${id}/remove-member/`,

  CreateVerificationSession: `${domain}/verification/create_session/`,

  CreateReviewRequest: `${domain}/reviews/create/`,
  ReviewStats: `${domain}/reviews/stats/`,

  // Review Submission Endpoint (recipient submits review in response to request)
  ReviewSubmit: `${domain}/reviews/submits/`,

  // Review Decision Endpoint (requester accepts/rejects review submission)
  DecideReviewSubmission: (submissionId) =>
    `${domain}/reviews/submissions/${submissionId}/decision/`,

  // Pending Reviews
  ReviewPending: `${domain}/reviews/pending/`,

  InviteExternalReviewer: `${domain}/reviews/invite/`,

  // Internal Review Flow
  ReviewList: `${domain}/reviews/`,
  ReviewDetail: (id) => `${domain}/reviews/${id}/`,
  ReviewReject: (id) => `${domain}/reviews/${id}/reject/`,

  ReviewInvitationDetails: (token) => `${domain}/reviews/invitation/${token}/`,
  ReviewInvitationEmail: (token) => `${domain}/reviews/invitation/${token}/email/`,
};

export const queryKeys = {
  // Project Query Keys
  ProjectList: (filtersKey) => ["projects", "list", filtersKey],
  ProjectListBase: () => ["projects", "list"],
  ProjectDetail: (projectId) => ["projects", "detail", projectId],
  MyTeams: (params) => ["teams", "my", params],
  // Teams Workspace Query Keys
  TeamDetail: (teamId) => ["teams", "detail", teamId],
  TeamMembers: (teamId) => ["teams", "members", teamId],
  TeamInvites: (teamId) => ["teams", "invites", teamId],
  TeamStorage: (teamId) => ["teams", "storage", teamId],
  TeamFiles: (teamId, filtersKey) => ["teams", "files", teamId, filtersKey],
  TeamFilesBase: (teamId) => ["teams", "files", teamId],
  TeamFolderTree: (teamId) => ["teams", "folders", teamId, "tree"],
  TeamInviteDetail: (token) => ["teams", "invite", "detail", token],

  ProjectTasks: (projectId, params) => ["projects", "tasks", projectId, params],
  ProjectTasksBase: (projectId) => ["projects", "tasks", projectId],
  GanttTasks: (projectId, params) => ["projects", "gantt", projectId, params],
  GanttTasksBase: (projectId) => ["projects", "gantt", projectId],
  CrossProjectGanttTasks: (params) => ["tasks", "gantt", params],
  CrossProjectGanttTasksBase: () => ["tasks", "gantt"],
  TaskDetail: (projectId, taskId) => ["projects", "task", projectId, taskId],
  TaskComments: (projectId, taskId, params) => [
    "projects",
    "tasks",
    "comments",
    projectId,
    taskId,
    params,
  ],
  TaskCommentsBase: (projectId, taskId) => [
    "projects",
    "tasks",
    "comments",
    projectId,
    taskId,
  ],
  ProjectMembers: (projectId, filters) => ["projects", "members", projectId, filters],

  // Dashboard Query Keys
  DashboardStats: () => ["dashboard", "stats"],
  Clients: (teamId, params) => ["clients", teamId, params],
  TaskTrend: (days) => ["dashboard", "task-trend", days],
  UpcomingTasks: (days, limit) => ["dashboard", "upcoming-tasks", days, limit],

  // Help & Support
  SupportArticles: (category) => ["support", "articles", category || "all"],
  SupportSubmissions: () => ["support", "submissions"],
  SupportSubmission: (publicId) => ["support", "submission", publicId],
  SupportAdminSubmissionsBase: () => ["support", "admin"],
  SupportAdminSubmissions: (filters) => ["support", "admin", filters],
  SupportAdminSubmission: (publicId) => ["support", "admin", "submission", publicId],

  // Cross-Account Query Keys
  CrossAccountProjects: (filtersKey) => ["projects", "cross-account", filtersKey],
  CrossAccountProjectsBase: () => ["projects", "cross-account"],
  CrossAccountTasks: (filtersKey) => ["tasks", "cross-account", filtersKey],
  CrossAccountTasksBase: () => ["tasks", "cross-account"],

  // Files Query Keys
  ProjectFiles: (projectId, filtersKey) => [
    "projects",
    "files",
    projectId,
    filtersKey,
  ],
  ProjectFilesBase: (projectId) => ["projects", "files", projectId],
  ProjectFilesUsage: (projectId) => ["projects", "files", projectId, "usage"],
  ProjectFolderTree: (projectId) => ["projects", "folders", projectId, "tree"],
  ProjectFileAttachments: (projectId, filtersKey) => [
    "projects",
    "file-attachments",
    projectId,
    filtersKey,
  ],
  ProjectFileAttachmentsForObject: (projectId, objectType, objectId) => [
    "projects",
    "file-attachments",
    projectId,
    objectType,
    objectId,
  ],
  ProjectFileWorkflowRefs: (projectId, fileId) => [
    "projects",
    "file-workflow-refs",
    projectId,
    fileId,
  ],

  // Profile Query Keys
  ProfileDetails: () => ["profile", "details"],
  ProfileCompletion: () => ["profile", "completion"],
  PortfolioImages: () => ["profile", "portfolio-images"],
  RolesInterests: () => ["profile", "roles-interests"],

  // Partners Query Keys
  SignupSuggestions: () => ["partners", "signup-suggestions"],
  NetworkFilter: (input) => ["network-filter", input],
  UserNetwork: () => ["partners", "user-network"],
  SuggestedPartnerDetails: (id) => ["partners", "suggested-details", id],
  PartnersListing: (pagination) => ["partners", "listing", pagination],
  FilteredPartners: (key) => ["partners", "filtered", key],

  // Review Query Keys
  ReviewRequest: (id) => ["reviews", "request", id],
  ReviewRequests: () => ["reviews", "requests"],
  ReviewSubmissions: (submissionId) => ["reviews", "submissions", submissionId],
  ReviewPending: () => ["reviews", "pending"],
  ReviewInvitation: (token) => ["reviews", "invitation", token],
  ReviewInvitationEmail: (token) => ["reviews", "invitation", "email", token],
  ProjectInviteDetail: (token) => ["projects", "invite", "detail", token],
  ReviewStats: () => ["reviews", "stats"],
  ReviewRequestsList: (filters) => ["reviews", "list", filters],

  AIChatSessions: (projectId) => ["ai-chat", "sessions", projectId],
  AIChatSession: (sessionId) => ["ai-chat", "session", sessionId],
  AIChatMessages: (sessionId, page) => ["ai-chat", "messages", sessionId, page],
  AIChatContract: (contractId) => ["ai-chat", "contract", contractId],
  AIChatGrant: (sessionId) => ["ai-chat", "grant", sessionId],
  AIChatAccessRequests: (sessionId) => ["ai-chat", "access-requests", sessionId],
  AIChatMessageCitations: (sessionId, messageId) => [
    "ai-chat",
    "citations",
    sessionId,
    messageId,
  ],
  KnowledgeItems: (teamId) => ["knowledge", "items", teamId],
  KnowledgeSearch: (teamId, q) => ["knowledge", "search", teamId, q],

  // Chat Query Keys
  GroupMembers: (channelId) => ["chat", "group-members", channelId],
  GroupAvailableUsers: (channelId) => ["chat", "available-users", channelId],

  // Location Query Keys
  Cities: (stateId) => ["locations", "cities", stateId],

};
